












































import { mapGetters } from 'vuex';
import { TranslateResult } from 'vue-i18n';
import mixins from 'vue-typed-mixins';
import LocationBasedMixin from '@/Shared/LocationBasedMixin';
import { SearchPayload } from '@/Stores/AppealStore';
import { LetterType } from '@/Letters/Enums';
import constants from '@/constants';
import fileSaver from 'file-saver';
import VatsAPI from '@/Shared/VatsAPI';

const msgBoxOptions = {
    centered: true,
    okVariant: 'danger',
    cancelDisabled: true,
    modalClass: 'deleteRowClass',
    hideBackdrop: true
};
const saveMsgBoxOptions = {
    centered: true,
    okVariant: 'success',
    hideBackdrop: true
};
export default mixins(LocationBasedMixin).extend({
    data() {
        return {
            i18nPrefix: 'appeals.appealInfo',
            selectedLetter: 0
        };
    },
    computed: {
        ...mapGetters('appealModule', [
            'searchError',
            'searchInProgress',
            'getAppealInfo',
            'searchParams',
            'getSearchResults',
            'appealInfoLoaded',
            'appellantLoaded',
            'checkAppellantRequiredFields'
        ]),
        appealLetterList() {
            if (this.getAppealInfo != null && this.getAppealInfo.hasOwnProperty('appealLetterList')) {
                return this.getAppealInfo.appealLetterList || [];
            }
            return [];
        }
    },
    mounted() {
        if (!this.getSearchResults.citationNumber) {
            return;
        }
        if (!this.searchParams.citationNumber) {
            return;
        }
        if (this.appealInfoLoaded) {
            return;
        }
        const payload: SearchPayload = {
                parameters: this.searchParams,
                location: this.$typedStore.state.currentLocation
            };

        this.$typedStore.modules.appealModule.actions.searchAppealInfo(payload);
    },
    methods: {
        async printLetter() {
            if (!this.$data.selectedLetter) {
                const message: TranslateResult = this.$t('appeals.hearingLetters.selectAnOption');
                await this.$bvModal.msgBoxConfirm(message.toString(), msgBoxOptions);
                return;
            }

            const response = (await VatsAPI.post<Blob>(`/${this.$typedStore.state.currentLocation.urlSegment}/citations/letters`,
            {
                action: 'Print',
                citationNumber: this.getSearchResults.citationNumber,
                UserName: this.$typedStore.modules.userModule.getters.userName,
                letterType: LetterType[this.$data.selectedLetter]
            },
            {
                headers: {
                    accept: constants.OctetMimeType
                },
                responseType: 'blob'
            }));
            fileSaver.saveAs(response.data, LetterType[this.$data.selectedLetter] + '.pdf');
        },
        async emailLetter() {
            if (!this.$data.selectedLetter) {
                const message: TranslateResult =
                this.$t('appeals.hearingLetters.selectAnOption');

                await this.$bvModal.msgBoxConfirm(message.toString(), msgBoxOptions);
                return;
            }

            if (this.checkAppellantRequiredFields) {
                const response = (await VatsAPI.post<Blob>(`/${this.$typedStore.state.currentLocation.urlSegment}/citations/letters`,
                {
                    action: 'Email',
                    citationNumber: this.getSearchResults.citationNumber,
                    UserName: this.$typedStore.modules.userModule.getters.userName,
                    letterType: LetterType[this.$data.selectedLetter]
                },
                {
                    headers: {
                        accept: constants.OctetMimeType
                    },
                    responseType: 'blob'
                }));

                fileSaver.saveAs(response.data, LetterType[this.$data.selectedLetter] + '.pdf');
                const message: TranslateResult = this.$t('appeals.hearingLetters.emailSuccessfulTitle');

                await this.$bvModal.msgBoxConfirm(message.toString(), saveMsgBoxOptions);
            } else {
                const message: TranslateResult = this.$t('appeals.hearingLetters.appellantRequired');

                if (await this.$bvModal.msgBoxConfirm(message.toString(), msgBoxOptions)) {
                    this.$router.push({
                        name: 'information', params: { location: this.location }
                    });
                } else {
                    return;
                }
            }
        }
    }
});
